










import { Vue, Component } from 'vue-property-decorator';
import AltasDeServicio from '@/pantallas/Conecta/AltasServicio/index.vue';

@Component({
  components: { AltasDeServicio },
})
export default class AltasDeServicioPantalla extends Vue {}
